<template>
    <div class="callStatisticsBox">
        <div style="display: flex">
            <el-form ref="listArgument" :model="listArgument">
                <el-form-item v-if="user_type==2" prop="zuoxi_mobile">
                    <el-select
                        v-model="listArgument.zuoxi_mobile"
                        class="filter-item common-r"
                        placeholder="请选择坐席"
                    >
                        <el-option
                            v-for="item in seatsList"
                            :key="item.mobile"
                            :label="item.name"
                            :value="item.mobile">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-date-picker
                        v-model="value"
                        :default-time="['00:00:00', '23:59:59']"
                        type="datetimerange"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        @change="chosedatetime"
                        :picker-options="pickerOptions"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        >
                    </el-date-picker>
                </el-form-item>
            </el-form>
            <div class="searchBox">
                <el-button type="primary" @click="searchBtn">搜索</el-button>
                <el-button @click="clearBtn">清空</el-button>
            </div>
        </div>
<!--        线索统计-->
        <div class="callStatistics">
            <div class="title">
                <div class="triangle"></div>
                <h5>线索统计</h5>
            </div>
            <div class="contentBox">
                <div>
                    <h5>新增线索数</h5>
                    <p>{{statisticsData.new_xs_num}}</p>
                </div>
                <div >
                    <h5>新增跟进记录</h5>
                    <p>{{statisticsData.new_gj_num}}</p>
                </div>
            </div>
        </div>
<!--        通话记录-->
        <div class="call">
            <div class="title">
                <div class="triangle"></div>
                <h5>通话统计</h5>
            </div>
            <div class="contentBox">
                <div>
                    <h5>坐席总数</h5>
                    <p>{{statisticsData.zuoxi_total_num}}</p>
                </div>
                <div>
                    <h5>总拨打数</h5>
                    <p>{{statisticsData.boda_total_num}}</p>
                </div>
                <div>
                    <h5>总接通数</h5>
                    <p>{{statisticsData.jietong_total_num}}</p>
                </div>
                <div>
                    <h5>接通率</h5>
                    <p>{{statisticsData.jietong_lv}}</p>
                </div>
                <div>
                    <h5>总通话时长</h5>
                    <p>{{statisticsData.tonghua_total_num}}</p>
                </div>
                <div>
                    <h5>平均通话时长</h5>
                    <p>{{statisticsData.tonghua_pingjun_num}}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { callStatisticsData, getSeatsList } from '@/api/callCenter';

export default {
    name: 'callStatistics',
    data() {
        return {
            listArgument:{
                zuoxi_mobile:'',
                begin_time:'',
                end_time:''
            },
            statisticsData:'',
            pickerOptions: {
                shortcuts: [
                    {
                        text: '今天',
                        onClick(picker) {
                            const start = new Date();
                            start.setHours(0, 0, 0, 0);
                            const end = new Date();
                            end.setHours(23, 59, 59, 999);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '昨天',
                        onClick(picker) {
                            const end = new Date();
                            end.setDate(end.getDate() - 1);
                            end.setHours(23, 59, 59, 999);
                            const start = new Date(end);
                            start.setHours(0, 0, 0, 0);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            end.setHours(23, 59, 59, 999);  // 结束时间设为当天最后一刻
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            start.setHours(0, 0, 0, 0);  // 开始时间归零
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            end.setHours(23, 59, 59, 999);
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            start.setHours(0, 0, 0, 0);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            end.setHours(23, 59, 59, 999);
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            start.setHours(0, 0, 0, 0);
                            picker.$emit('pick', [start, end]);
                        }
                    }]
            },
            value: [],
            seatsList:[],
            user_type:'',
        };
    },
    methods:{
        chosedatetime(obj){
            if(obj){
                this.listArgument.begin_time = obj[0]
                this.listArgument.end_time = obj[1]
            }else{
                this.listArgument.begin_time = ''
                this.listArgument.end_time = ''
            }
        },
        // 搜索
        searchBtn(){
            this.getData()
        },
        // 清空
        clearBtn(){
            this.value=[];
            this.listArgument.zuoxi_mobile=''
            this.listArgument.begin_time=''
            this.listArgument.end_time=''
            this.getData()
        },
        getData(){
            callStatisticsData(this.listArgument).then(res=>{
                if (res.code==200){
                    this.statisticsData=res.data
                }else {
                    this.$message.error(res.msg);
                }
            })
        }
    },
    created() {
        this.user_type=JSON.parse(sessionStorage.getItem('shenfen')).user_type;
        getSeatsList().then(res=>{
            if (res.code==200){
                this.seatsList=res.data.list;
            }else{
                this.$message.error(res.msg);
            }
        })
        this.getData()

    }
}
</script>

<style scoped lang="scss">
    .callStatisticsBox{
        background-color: #fff;
        padding: 20px;
        border-radius: 5px;
    }
    .el-form{
        display: flex;
        align-items: center;
    }
    .el-form-item{
        margin-right: 10px;
    }
    .callStatistics, .call{
        margin:10px 0
    }
    .title{
        display: flex;
        align-items: center;
        //color: #409EFF;
    }
    //.triangle{
    //    width: 0px;
    //    height: 0px;
    //    border-style: solid;
    //    border-width: 0 5px 10px;
    //    border-color:transparent transparent #409EFF;
    //    margin-right: 10px;
    //}
    .contentBox{
        display: flex;
        align-items: center;
        margin: 20px 0;
        height: 100px;
        border: 1px dashed #d9d9d9;
        border-radius: 5px;
        div{
            width: 200px;
            text-align: center;
            h5{
                margin-bottom: 10px;
                //color: #409eff;
            }
            p{
                font-size: 14px;
            }
        }
    }

</style>